import { render, staticRenderFns } from "./MobileDesktopAppAccordion.vue?vue&type=template&id=3a68ae14&scoped=true"
import script from "./MobileDesktopAppAccordion.vue?vue&type=script&lang=ts"
export * from "./MobileDesktopAppAccordion.vue?vue&type=script&lang=ts"
import style0 from "./MobileDesktopAppAccordion.vue?vue&type=style&index=0&id=3a68ae14&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a68ae14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/Control-Panel/Control-Panel-Preprod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a68ae14')) {
      api.createRecord('3a68ae14', component.options)
    } else {
      api.reload('3a68ae14', component.options)
    }
    module.hot.accept("./MobileDesktopAppAccordion.vue?vue&type=template&id=3a68ae14&scoped=true", function () {
      api.rerender('3a68ae14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmailAccounts/MobileDesktopAppAccordion.vue"
export default component.exports